/* ---------- Catering permissions — the pure model (no network); the read itself is in cateringAccessApi.ts ---------- */

/**
 * CATERING section of the employee Roles & Functions editor (sections come from GET /api-info).
 * An Edit permission implies its View. Magil_Admin (Brisque Admin) always has everything.
 */
export const CATERING_MODULE = 'CATERING';
export const VIEW_BOOKINGS = 'View Bookings';
export const EDIT_BOOKINGS = 'Edit Bookings';
export const VIEW_CUSTOMERS = 'View Customers';
export const VIEW_PACKAGES = 'View Packages';
export const EDIT_PACKAGES = 'Edit Packages';
export const VIEW_EDIT_SETTINGS = 'View/Edit Settings';
export const CATERING_ADMIN_ROLE = 'Magil_Admin';

export interface CateringAccess {
  viewBookings: boolean;
  editBookings: boolean;
  viewCustomers: boolean;
  viewPackages: boolean;
  editPackages: boolean;
  /** View/Edit Settings — the Catering Settings page. */
  settings: boolean;
  /** Brisque Admin: full access everywhere (incl. what no permission covers, e.g. editing customer tags). */
  admin: boolean;
}

export const NO_CATERING_ACCESS: CateringAccess = {
  viewBookings: false, editBookings: false, viewCustomers: false, viewPackages: false, editPackages: false, settings: false, admin: false,
};
export const FULL_CATERING_ACCESS: CateringAccess = {
  viewBookings: true, editBookings: true, viewCustomers: true, viewPackages: true, editPackages: true, settings: true, admin: true,
};

const norm = (value: unknown) => String(value ?? '').trim().toLowerCase();

/** Reads CATERING from the staff permissions response: [{ module, funtions: [name] }] (the backend spells it "funtions"). */
export function cateringAccessOf(res: any): CateringAccess {
  const list = [res, res?.metaDataInfo?.data, res?.data].find(Array.isArray) ?? [];
  const mod = list.find((m: any) => norm(m?.module) === norm(CATERING_MODULE));
  const fns: unknown[] = mod?.funtions ?? mod?.functions ?? mod?.functionality ?? [];
  const names = new Set(fns.map((f: any) => norm(typeof f === 'string' ? f : f?.name ?? f?.displayName)));
  const has = (name: string) => names.has(norm(name));
  const editBookings = has(EDIT_BOOKINGS);
  const editPackages = has(EDIT_PACKAGES);
  return {
    viewBookings: editBookings || has(VIEW_BOOKINGS),
    editBookings,
    viewCustomers: has(VIEW_CUSTOMERS),
    viewPackages: editPackages || has(VIEW_PACKAGES),
    editPackages,
    settings: has(VIEW_EDIT_SETTINGS),
    admin: false,
  };
}
